import React, { ReactNode } from "react";

interface TooltipProps {
  children: ReactNode;
  tooltip: string;
  position?: "top" | "bottom" | "left" | "right";
}

export const CustomTooltip: React.FC<TooltipProps> = ({
  children,
  tooltip,
  position = "top",
}) => {
  const positionClasses = {
    top: "-top-[40px] left-1/2 -translate-x-1/2",
    bottom: "-bottom-[40px] left-1/2 -translate-x-1/2",
    left: "top-1/2 -left-[40px] -translate-y-1/2",
    right: "top-1/2 -right-[40px] -translate-y-1/2",
  };

  return (
    <div className="group relative inline-block">
      {children}
      <div
        className={`invisible absolute ${positionClasses[position]} z-50 min-w-[50px] max-w-[350px] whitespace-nowrap rounded-md border border-[#F2F2F2] bg-[#FFFFFF] px-2 py-1 text-sm text-[#202020] shadow-lg group-hover:visible`}
      >
        {tooltip}
      </div>
    </div>
  );
};
